import "rc-rate/assets/index.css";

import React, { ReactNode } from "react";

import Rate from "rc-rate";
import styled from "styled-components/macro";

type RcStyleProps = {
  colorActive: string;
};

type Props = {
  defaultValue?: number;
  handleChange?: (e: number) => void;
  size: number;
  style?: Object;
  disabled?: boolean;
  character?: ReactNode;
} & RcStyleProps;

const Rcrating: React.FC<Props> = ({
  defaultValue,
  handleChange,
  size,
  style,
  colorActive,
  disabled,
  character = "★",
}) => (
  <Container
    style={{ fontSize: size, ...style }}
    colorActive={colorActive}
    count={5}
    defaultValue={defaultValue}
    allowHalf
    allowClear={false}
    onChange={handleChange}
    disabled={disabled}
    character={character}
  />
);

const Container = styled(Rate)<RcStyleProps>`
  .rc-rate-star {
    > div:focus {
      outline: none;
    }
  }

  .rc-rate-star-half .rc-rate-star-first,
  .rc-rate-star-full .rc-rate-star-second {
    color: ${({ colorActive }) => colorActive};
  }
`;

Rcrating.defaultProps = {
  size: 48,
};

export default Rcrating;
